import * as s from "./CvvStyled";
import {
  CVVPairItem,
  DayNightItem,
} from "api/interfaces/reportInterface.interface";
import { CVVType } from "./interface";
import { CvvBase } from "./CvvContainer";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { checkCVVError, checkEmpty } from "utils/functions";
import { Fragment } from "react";
import CVVThumbnail from "components/atoms/image/thumbnail/CVVThumbnail";
import {
  CvvCameraThumbnailReferenceInfo,
  CvvCameraThumbnailEventInfo,
} from "./CvvCameraThumbnailInfo";
import SmallLabel from "components/atoms/text/labels/SmallLabel";
import { COLORS } from "styles/colors";
import { cvvEvent } from "./constants";
import ProtectedThumbnail from "components/atoms/image/thumbnail/ProtectedThumbnail";
import NoPermissionThumbnail from "components/atoms/image/thumbnail/NoPermission";

type CvvCameraThumbnailPairProps = {
  data: DayNightItem;
  type: CVVType;
  onChangeOpen: (
    data: DayNightItem,
    pairItem: CVVPairItem,
    base: CvvBase
  ) => void;
  onClickUpdate: (data: DayNightItem, pairItem: CVVPairItem) => Promise<void>;
  onClickCheckNow: () => Promise<void>;
  selectedAccount: ProfileAccountInfo;
  timezoneOffset: number;
  timezone: string;
  disabledCheckNow: boolean;
  isProtected: boolean;
};

export default function CvvCameraThumbnailPair({
  data,
  type,
  onChangeOpen,
  onClickCheckNow,
  selectedAccount,
  timezoneOffset,
  timezone,
  disabledCheckNow,
  isProtected,
  ...props
}: CvvCameraThumbnailPairProps) {
  // event 에 하나라도 true 가 있으면 true
  const pairItem: CVVPairItem = data[type] as CVVPairItem;

  // console.log(pairItem);

  const onClickUpdate = () => {
    return props.onClickUpdate(data, pairItem);
  };

  // 추후 base, last [key] 값으로 구별 방식으로 리팩토링 필요
  return (
    <Fragment key={type}>
      <ThumbnailReference
        onImageClick={() => onChangeOpen(data, pairItem, CvvBase.REFERENCE)}
        onClickUpdate={onClickUpdate}
        pairItem={pairItem}
        type={type}
        timezoneOffset={timezoneOffset}
        timezone={timezone}
        isProtected={isProtected}
        isNoPermission={!data.permission}
      />

      <ThumbnailEvent
        onImageClick={() => onChangeOpen(data, pairItem, CvvBase.EVENT)}
        onClickCheckNow={onClickCheckNow}
        pairItem={pairItem}
        disabledCheckNow={disabledCheckNow}
        timezoneOffset={timezoneOffset}
        timezone={timezone}
        isProtected={isProtected}
        isNoPermission={!data.permission}
      />
    </Fragment>
  );
}

type ThumbnailReferenceProps = {
  pairItem: CVVPairItem;
  type: CVVType;
  onImageClick: () => void;
  onClickUpdate: () => Promise<void>;
  timezoneOffset: number;
  timezone: string;
  showAnalyzingCover?: boolean;
  isProtected: boolean;
  isNoPermission: boolean;
};

const ThumbnailReference = ({
  onImageClick,
  onClickUpdate,
  pairItem,
  type,
  timezoneOffset,
  timezone,
  isProtected,
  isNoPermission,
}: ThumbnailReferenceProps) => {
  const key = `${pairItem.referenceThumbnail.date}-${pairItem.referenceThumbnail.thumbnailId}`;
  return (
    <s.CameraThumbnail>
      {isProtected ? (
        <ProtectedThumbnail />
      ): isNoPermission ? (
        <NoPermissionThumbnail />
      ) : (
        <s.ThumbnailImage
          onClick={onImageClick}
          data-testid="reports-view-cvv-thumbnail-image-image"
        >
          {/* {isError && index === 1 && <s.ErrorBorder></s.ErrorBorder>} */}

          <CVVThumbnail
            key={key}
            errorStatus={
              pairItem !== undefined &&
              !checkEmpty(pairItem.referenceThumbnail.errorStatus)
                ? `${pairItem.referenceThumbnail.errorStatus}`
                : undefined
            }
            videoLoss={false}
            thumbnailUrl={
              pairItem !== undefined &&
              !checkEmpty(pairItem.referenceThumbnail.url)
                ? `${pairItem.referenceThumbnail.url}?v=${Date.now()}`
                : undefined
            }
            eventDate={pairItem.referenceThumbnail.date}
            showAnalyzingCover={false}
          />

          {/* <img
          src={pairItem !== undefined && !checkEmpty(pairItem.referenceThumbnail.url) ? pairItem.referenceThumbnail.url : WARNING_CIRCLE_ICON}
          alt="reference_thumbnail_night"
          /> */}
        </s.ThumbnailImage>
      )}

      <CvvCameraThumbnailReferenceInfo
        pairItem={pairItem}
        dayOrNight={type}
        onClickUpdate={onClickUpdate}
        timezone={timezone}
        isProtected={isProtected}
      />
    </s.CameraThumbnail>
  );
};

type ThumbnailEventProps = {
  pairItem: CVVPairItem;
  onImageClick: () => void;
  onClickCheckNow: () => Promise<void>;
  timezoneOffset: number;
  timezone: string;
  disabledCheckNow: boolean;
  isProtected: boolean;
  isNoPermission: boolean;
};

const ThumbnailEvent = ({
  onImageClick,
  onClickCheckNow,
  pairItem,
  timezoneOffset,
  timezone,
  disabledCheckNow,
  isProtected,
  isNoPermission,
}: ThumbnailEventProps) => {
  let isError = false;
  if (pairItem !== undefined) {
    isError = checkCVVError(pairItem.eventThumbnail);
  }
  const key = `${pairItem.eventThumbnail.date}-${pairItem.eventThumbnail.thumbnailId}`;

  // TODO: isAnalyzing 표시

  return (
    <s.CameraThumbnail>
      {isProtected ? (
        <ProtectedThumbnail />
      ) : isNoPermission ? (
        <NoPermissionThumbnail />
      ) : (
        <s.ThumbnailImage
          onClick={onImageClick}
          data-testid="reports-view-cvv-thumbnail-image-image-2"
        >
          {isError && <s.ErrorBorder></s.ErrorBorder>}
          {isError && (
            <s.ErrorWrapper>
              {cvvEvent.map((evt, index) => {
                if (pairItem.eventThumbnail[evt] === true) {
                  return (
                    <SmallLabel label={evt} color={COLORS.RED} key={index} />
                  );
                } else return null;
              })}
            </s.ErrorWrapper>
          )}

          <CVVThumbnail
            key={key}
            errorStatus={
              pairItem !== undefined &&
              !checkEmpty(pairItem.eventThumbnail.errorStatus)
                ? `${pairItem.eventThumbnail.errorStatus}`
                : undefined
            }
            videoLoss={false}
            thumbnailUrl={
              pairItem !== undefined && !checkEmpty(pairItem.eventThumbnail.url)
                ? `${pairItem.eventThumbnail.url}?v=${Date.now()}`
                : undefined
            }
            eventDate={pairItem.eventThumbnail.date}
            isAnalyzing={pairItem.eventThumbnail.isAnalyzing}
            showAnalyzingCover={true}
          />

          {/* <img src={pairItem !== undefined && !checkEmpty(pairItem.eventThumbnail.url) ? pairItem.eventThumbnail.url : WARNING_CIRCLE_ICON} alt="" /> */}
        </s.ThumbnailImage>
      )}

      <CvvCameraThumbnailEventInfo
        pairItem={pairItem}
        onClickCheckNow={onClickCheckNow}
        timezone={timezone}
        disabledCheckNow={disabledCheckNow}
        isProtected={isProtected}
      />
    </s.CameraThumbnail>
  );
};
